export default __webpack_public_path__ + "static/article-wedding-post-wedding-cash-splash-0cb1d23e4ee30c3070c81931d9047646.jpg";